import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  // Dynamic: render.php builds the toggle's radios and ids, which cannot be
  // written at save time because they have to be unique per rendered instance.
  save: () => <InnerBlocks.Content />,
  icon: {
    foreground: '#0061FE',
    src: (
      // Three columns, the middle one raised — a pricing row at a glance.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2.5" y="8" width="5.5" height="11" rx="1.5" />
        <rect x="9.25" y="5" width="5.5" height="14" rx="1.5" />
        <rect x="16" y="8" width="5.5" height="11" rx="1.5" />
      </svg>
    ),
  },
});
